import { computed, DestroyRef, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { patchState, signalStore, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { removeAllEntities, setAllEntities, withEntities } from '@ngrx/signals/entities';
import { SignalStoreResetRegistry } from '../../../modules/shared/signal-store';

export const UserMetricGroupStore = signalStore(
  { providedIn: 'root' },
  withEntities<{ id: string }>(),
  withState({ loaded: false, loading: false }),
  withProps((store) => ({
    entities$: toObservable(store.entities),
    count$: toObservable(computed(() => store.entities().length)),
    loading$: toObservable(store.loading),
  })),
  withMethods((store) => ({
    setAll: (groups: { id: string }[]) => patchState(store, setAllEntities(groups), { loaded: true }),
    setLoading: (loading: boolean) => patchState(store, { loading }),
    resetCache: () => patchState(store, { loaded: false }),
    reset: () => patchState(store, removeAllEntities(), { loaded: false, loading: false }),
    hasAvailableMetricGroup: (metricGroup: string) =>
      store.entities().some(x => x.id === metricGroup),
    hasAnyAvailableMetricGroup: (metricGroups: string[]) =>
      store.entities().some(x => metricGroups.includes(x.id)),
  })),
  withHooks({
    onInit(store) {
      const registry = inject(SignalStoreResetRegistry);
      const unregister = registry.register(() => store.reset());
      inject(DestroyRef).onDestroy(unregister);
    },
  })
);
